import { render, staticRenderFns } from "./ksglf.vue?vue&type=template&id=d15a920e&scoped=true"
import script from "./ksglf.vue?vue&type=script&lang=js"
export * from "./ksglf.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/rem.css?vue&type=style&index=0&id=d15a920e&prod&scoped=true&lang=css&external"
import style1 from "./ksglf.vue?vue&type=style&index=1&id=d15a920e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a920e",
  null
  
)

export default component.exports